import { render, staticRenderFns } from "./MaterialStatsCard2.vue?vue&type=template&id=8427f822&"
import script from "./MaterialStatsCard2.vue?vue&type=script&lang=js&"
export * from "./MaterialStatsCard2.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatsCard2.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports